<div class="padding-small bg-light-grey padding-left-large small">
  <div class="flex center">Insights</div>
</div>

<div class="page-layout padding-large m-margin-none m-padding m-padding-top-largest">
  <bt-page-header title="Style prices" subtitle="Average shooting price of each style and how it changes over time" icon="fa-regular fa-chart-bar"></bt-page-header>

  <div class="flex center margin-bottom-small">
    <i class="fa-solid fa-calendar margin-right-smallest"></i>
    <b class="margin-right-smallest">Period</b>

    <div class="flex wrap gap center margin-left">
      <span class="primary hover" (click)="setDateUtils(1)">Current year</span>
      |
      <span class="primary hover" (click)="setDateUtils(2)">Last year</span>
      |
      <span class="primary hover" (click)="setDateUtils(3)">Current month</span>
      |
      <span class="primary hover" (click)="setDateUtils(4)">Last month</span>
    </div>
  </div>

  <div class="flex wrap gap margin-bottom-small">
    <div class="filter-chip" [ngClass]="!styleFilters.dateRange ? '' : 'selected'">
      @if (styleFilters.dateRange) {
        <div class="flex center hover" (click)="openDateRangeFilterModal()">
          <b class="margin-right-smallest">Date Range:</b>

          {{ styleFilters.dateRange.from | date: 'dd-MM-yyyy' }} - {{ styleFilters.dateRange.to | date: 'dd-MM-yyyy' }}
        </div>
        <mat-icon>edit</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openDateRangeFilterModal()">
          Date Range
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>
  </div>

  <div class="flex center margin-bottom-small margin-top">
    <i class="fa-solid fa-filter margin-right-smallest"></i>
    <b>Filters:</b>
  </div>

  <div class="flex wrap gap margin-bottom-small">
    <div class="filter-chip" [ngClass]="!styleFilters.styleCode ? '' : 'selected'">
      @if (styleFilters.styleCode) {
        <div class="flex center hover" (click)="openStyleCodesFilter()">
          <b class="margin-right-smallest">Style Code:</b>
          {{ styleFilters.styleCode }}
        </div>

        <mat-icon class="hover" (click)="cleanFilter('styleCode')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openStyleCodesFilter()">
          Style Code
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!styleFilters.orderIds || !styleFilters.orderIds.length ? '' : 'selected'">
      @if (styleFilters.orderIds && styleFilters.orderIds.length) {
        <div class="flex center hover" (click)="openOrderIdsFilter()">
          <b class="margin-right-smallest">Order ID:</b>
          @for (id of styleFilters.orderIds; track id; let last = $last) {
            {{ id }}
            @if (!last) {
              ,
            }
          }
        </div>

        <mat-icon class="hover" (click)="cleanFilter('orderIds')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openOrderIdsFilter()">
          Order ID
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!styleFilters.basicNetIds || !styleFilters.basicNetIds.length ? '' : 'selected'">
      @if (styleFilters.basicNetIds && styleFilters.basicNetIds.length) {
        <div class="flex center hover" (click)="openBasicNetIdsFilter()">
          <b class="margin-right-smallest">BasicNet ID:</b>
          @for (id of styleFilters.basicNetIds; track id; let last = $last) {
            {{ id }}
            @if (!last) {
              ,
            }
          }
        </div>

        <mat-icon class="hover" (click)="cleanFilter('basicNetIds')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openBasicNetIdsFilter()">
          BasicNet ID
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!styleFilters.brands || !styleFilters.brands.length ? '' : 'selected'">
      @if (styleFilters.brands && styleFilters.brands.length) {
        <div class="flex center hover" (click)="openBrandFilterModal()">
          <b class="margin-right-smallest">Brand:</b>

          @for (brand of styleFilters.brands; track brand; let last = $last) {
            {{ brand.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('brands')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openBrandFilterModal()">
          Brand
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!styleFilters.categories || !styleFilters.categories.length ? '' : 'selected'">
      @if (styleFilters.categories && styleFilters.categories.length) {
        <div class="flex center hover" (click)="openCategoryFilterModal()">
          <b class="margin-right-smallest">Category:</b>
          @for (category of styleFilters.categories; track category; let last = $last) {
            {{ category.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('categories')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openCategoryFilterModal()">
          Category
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div
      class="filter-chip"
      [ngClass]="!styleFilters.styleGroups || !styleFilters.styleGroups.length ? '' : 'selected'"
    >
      @if (styleFilters.styleGroups && styleFilters.styleGroups.length) {
        <div class="flex center hover" (click)="openStyleGroupFilterModal()">
          <b class="margin-right-smallest">Style Group:</b>
          @for (styleGroup of styleFilters.styleGroups; track styleGroup; let last = $last) {
            {{ styleGroup.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('styleGroups')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openStyleGroupFilterModal()">
          Style Group
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div
      class="filter-chip"
      [ngClass]="!styleFilters.styleDescriptions || !styleFilters.styleDescriptions.length ? '' : 'selected'"
    >
      @if (styleFilters.styleDescriptions && styleFilters.styleDescriptions.length) {
        <div class="flex center hover" (click)="openStyleDescriptionFilterModal()">
          <b class="margin-right-smallest">Style Description:</b>
          @for (styleDescription of styleFilters.styleDescriptions; track styleDescription; let last = $last) {
            {{ styleDescription.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('styleDescriptions')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openStyleDescriptionFilterModal()">
          Style Description
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div
      class="filter-chip"
      [ngClass]="!styleFilters.collections || !styleFilters.collections.length ? '' : 'selected'"
    >
      @if (styleFilters.collections && styleFilters.collections.length) {
        <div class="flex center hover" (click)="openCollectionFilterModal()">
          <b class="margin-right-smallest">Collection:</b>
          @for (collection of styleFilters.collections; track collection; let last = $last) {
            {{ collection.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('collections')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openCollectionFilterModal()">
          Collection
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!styleFilters.purposes || !styleFilters.purposes.length ? '' : 'selected'">
      @if (styleFilters.purposes && styleFilters.purposes.length) {
        <div class="flex center hover" (click)="openPurposeFilterModal()">
          <b class="margin-right-smallest">Purpose:</b>
          @for (purpose of styleFilters.purposes; track purpose; let last = $last) {
            {{ purpose.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('purposes')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openPurposeFilterModal()">
          Purpose
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!styleFilters.genders || !styleFilters.genders.length ? '' : 'selected'">
      @if (styleFilters.genders && styleFilters.genders.length) {
        <div class="flex center hover" (click)="openGenderFilterModal()">
          <b class="margin-right-smallest">Gender:</b>
          @for (gender of styleFilters.genders; track gender; let last = $last) {
            {{ gender.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('genders')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openGenderFilterModal()">
          Gender
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!styleFilters.teams || !styleFilters.teams.length ? '' : 'selected'">
      @if (styleFilters.teams && styleFilters.teams.length) {
        <div class="flex center hover" (click)="openTeamFilterModal()">
          <b class="margin-right-smallest">Team:</b>
          @for (team of styleFilters.teams; track team; let last = $last) {
            {{ team.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('teams')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openTeamFilterModal()">
          Team
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>
  </div>

  @if (styles && styles.items && styles.items.length) {
    <div class="flex center between full-width">
      <div class="flex center gap">
        @if (selectedStyles.length > 0) {
          <span class="hover" (click)="deselectAll()">
            <b class="margin-right-smallest">{{ selectedStyles.length }}</b>
            selected
          </span>

          <span class="red flex center hover" (click)="deselectAll()">
            <i class="fa fa-xmark margin-right-smallest"></i>
            Deselect all
          </span>
        }
      </div>

      <div class="flex center">
        <bt-paginator
          [pageNumber]="styles.currentPage"
          [pageSize]="styles.size"
          [totalNumber]="styles.totalCount"
          (clickPage)="pageEvent($event)"
        ></bt-paginator>
      </div>
    </div>

    <table class="margin-top-smallest">
      <tr>
        <th>Brand</th>
        <th>Style</th>
        <th>Average price</th>
        <th>Price Changes</th>
        <th>Action</th>
      </tr>

      @for (item of styles.items; track item) {
        <tr>
          <td>{{ item.brand?.name }}</td>

          <td>
            <div class="flex column start">
              <div class="flex wrap">{{ item.code }} - {{ item.name }} - {{ item.gender.name }}</div>

              <span class="small grey">
                {{ item.category.name }} -
                {{ item.styleGroup.name != item.category.name ? item.styleGroup.name + ' - ' : '' }}
              </span>
            </div>
          </td>

          <td>
            @if (item.periodAverage >= 0 && item.priceChanges && item.priceChanges.length > 0) {
              <div class="flex column start">
                <h4 class="bg-primary white padding-right-smallest padding-left-smallest radius">
                  {{ item.periodAverage | currency: 'EUR' }}
                </h4>
                <small class="grey margin-top-smallest">
                  Based on {{ item.priceChanges?.length }} order{{ item.priceChanges?.length > 1 ? 's' : '' }}
                </small>
              </div>
            } @else {
              <span class="grey small">No data</span>
            }
          </td>

          <td class="price-chart">
            @if (item.priceChanges && item.priceChanges.length > 0) {
              @if (item.priceChanges.length > 1) {
                <canvas
                  baseChart
                  [type]="'line'"
                  [data]="chartConfigs.get(item.modelId!).data"
                  [options]="chartConfigs.get(item.modelId!).options"
                ></canvas>
              } @else {
                <span class="grey small">Not enough data</span>
              }
            } @else {
              <span class="grey small">No data</span>
            }
          </td>

          <td class="nowrap">
            <div class="flex center">
              <a [routerLink]="['/company/style-info/' + item.modelId]" class="hover flex center primary">
                <i class="fa-solid fa-caret-right margin-right-smallest"></i>
                Open style media
              </a>
            </div>
          </td>
        </tr>
      }
    </table>

    <bt-paginator
      [pageNumber]="styles.currentPage"
      [pageSize]="styles.size"
      [totalNumber]="styles.totalCount"
      [totalPages]="styles.totalPages"
      (clickPage)="pageEvent($event)"
    ></bt-paginator>
  }

  @if (styles.items.length == 0 && !loading) {
    <div class="flex center bg-light-grey padding-largest justify-center margin-top">
      <div class="flex column center gap">
        <i class="fa fa-search fa-2xl margin-bottom grey"></i>
        <span>No styles found</span>
      </div>
    </div>
  }
</div>

@if (loading) {
  <bt-loader></bt-loader>
}
